import {createContext, useEffect, useState} from "react";

const TechnicalEngagementContext = createContext();

export function TechnicalEngagementProvider({children}) {
    const [technicalEngagement, setTechnicalEngagement] = useState(
        {
            technicalEngagementId:null,
            subject:null,
            accountName:"",
            opportunity:"",
            pillar:"",
            subPillar:"",
            recordType:"012670000005mbWAAQ",
            status:"Planning",
            ownerId:"",
            dueDate:"",
            demoEnvironment:"DemoPoint",
            user:"",
            environmentId:"",
            blueprintName:"",
            iAnticipateProgressingThisDeal:null
        });
    return (
        <TechnicalEngagementContext.Provider value={{technicalEngagement, setTechnicalEngagement}}>{children}</TechnicalEngagementContext.Provider>
    );
}

export default TechnicalEngagementContext;
